/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon96IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon96Icon(props: Icon96IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 32 32"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M10 31V11a1 1 0 1 1 2 0v20a1 1 0 1 1-2 0M9 4a2 2 0 1 0-4 0 2 2 0 0 0 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M2 31V13a3 3 0 0 1 3-3h16a1 1 0 1 1 0 2H5a1 1 0 0 0-1 1v18a1 1 0 1 1-2 0"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M29 3a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H15a1 1 0 1 1 0-2h13V5H14a1 1 0 1 1 0-2z"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M21.515 21.126a1 1 0 0 1 1.359.389l5 9a1 1 0 1 1-1.748.97l-5-9a1 1 0 0 1 .389-1.359"
        }
      ></path>
    </svg>
  );
}

export default Icon96Icon;
/* prettier-ignore-end */
